export default __webpack_public_path__ + "static/media/ad5f64696bde46930aed4936814fcb71.png";